"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateRunningTotal = void 0;
const dayjs = require("dayjs");
const models_1 = require("../../models");
const orders_1 = require("../orders");
const getCheapestRoomTotal_1 = require("./getCheapestRoomTotal");
const calculateTransferTotal_1 = require("./calculateTransferTotal");
/**
 * Calculate the running total based on form data
 * @param {Object} params - Parameters for calculation
 * @param {Object} params.formData - The form data
 * @param {Array} params.hotels - Array of hotel objects
 * @param {Object} params.transferRateMatrix - Transfer rate data
 * @param {string} params.hotelStatus - Current hotel status
 * @returns {Object} Object containing total amount and currency
 */
const calculateRunningTotal = (formData, hotels, transferRateMatrix, hotelStatus) => {
    // If hotel is sold out or on enquiry, return special status
    if (hotelStatus === "SOLD_OUT") {
        return { total: 0, displayValue: "N/A", currency: "" };
    }
    if (hotelStatus === "ENQUIRE") {
        return { total: 0, displayValue: "ON REQUEST", currency: "" };
    }
    let total = 0;
    let currency = "";
    // Calculate golf totals
    formData?.courses?.itinerary?.forEach((item) => {
        if (item) {
            total += (0, orders_1.getOrderLineTotalByType)(item.config, "GOLF");
            currency = item?.config.supplier?.currency;
        }
    });
    // Find selected hotel
    const hotel = hotels.find((h) => h.id === formData?.hotel?.where_when_who?.hotel?.id);
    // Calculate hotel total
    if (hotel) {
        const totalGuests = (formData?.trip?.number_of_golfers || 0) +
            (formData?.trip?.number_of_non_golfers || 0) +
            (formData?.trip?.pga_pros?.count || 0);
        const cheapestRoomTotal = (0, getCheapestRoomTotal_1.getCheapestRoomTotal)(hotel, formData?.trip?.start_date || "", totalGuests, formData?.trip?.duration_days_nights || 0, formData?.discounts?.margin_discount_percentages?.hotels || 0);
        // Get actual price
        const actualRoomTotal = (0, orders_1.getOrderLineTotalByType)(formData.hotel, "HOTEL");
        // Use the higher of the two totals
        if (actualRoomTotal > cheapestRoomTotal.total) {
            total += actualRoomTotal;
        }
        else if (cheapestRoomTotal.total > 0) {
            total += cheapestRoomTotal.total;
        }
    }
    // Calculate transfer total
    if (transferRateMatrix && hotel) {
        const isFirstDayGolf = formData?.courses?.itinerary.some((x) => x?.config?.where_when_who?.date === formData?.trip?.start_date);
        const isLastDayGolf = formData?.courses?.itinerary.some((x) => x?.config?.where_when_who?.date ===
            dayjs(formData?.trip?.start_date)
                .add(formData?.trip?.duration_days_nights || 0, "day")
                .format("YYYY-MM-DD"));
        const isAirportTransfer = formData?.transfers?.type
            ? [models_1.TransferType.AIRPORT, models_1.TransferType.GOLF_AIRPORT].includes(formData?.transfers?.type)
            : false;
        const arrivalAirportId = isAirportTransfer && formData?.transfers?.arrival_airport_enabled
            ? formData?.transfers?.arrival_airport?.id
            : undefined;
        const departureAirportId = isAirportTransfer && formData?.transfers?.departure_airport_enabled
            ? formData?.transfers?.departure_airport?.id
            : undefined;
        const transferTotal = (0, calculateTransferTotal_1.calculateTransferTotal)(transferRateMatrix, formData?.transfers, formData?.trip?.start_date || "", formData?.trip?.duration_days_nights || 0, hotel?.transfer_area?.id, hotel?.id, formData?.courses.itinerary || [], isFirstDayGolf, isLastDayGolf, arrivalAirportId, departureAirportId);
        if (transferTotal > 0) {
            total += transferTotal;
        }
    }
    return { total, displayValue: "", currency };
};
exports.calculateRunningTotal = calculateRunningTotal;
